import cls from 'classnames';

import useStyles from './styles';
import ITabButton from './types';

function TabButton({ children, disabled, index, isSelected, onClick }: ITabButton) {
  const classes = useStyles();

  return (
    <div
      className={cls(classes.root, disabled && classes.disabled, isSelected && classes.selected)}
      onClick={() => onClick(index)}
    >
      {children}
    </div>
  );
}

export default TabButton;
